<template>
  <div class="login-content" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <div class="mask-content">
      <div class="top-content">
        <router-link to="/" class="head-name">维才考考试平台</router-link>
      </div>
      <!-- <el-form :model="form" ref="form" :rules="rules" class="login-from">
        <el-form-item prop="username">
          <el-input
            v-model.trim="form.username"
            placeholder="请输入手机号"
            autofocus
            type="text"
            @focus="focusKey = 'username'"
            @keyup.enter.native="handleLogin('form')"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model.trim="form.password"
            :maxlength="20"
            placeholder="请输入密码"
            type="password"
            @focus="focusKey = 'password'"
            @keyup.enter.native="handleLogin('form')"
          />
        </el-form-item>
        <div class="operate">
          <el-button type="primary" class="width-btn" @click="handleLogin('form')">确认登录</el-button>
        </div>
        <div class="flex-operate">
          <el-link type="primary" href="#/register">立即注册</el-link>
        </div>
      </el-form> -->
      <div class="card-content">
        <div class="head-title">考生登录</div>
        <div class="code-content">
          <img :src="codeUrl" alt="" class="login-code">
          <div v-if="needReload" class="code-mask" @click="refreshCode">
            <i class="el-icon-refresh-left" style="font-size: 48px;color: #fff;"></i>
          </div>
        </div>
        <div class="tip-text">请使用微信扫描二维码</div>
        <div class="tip-text tip-text-red">考生在招聘考试期间须全程保持关注公众号"维才考",以免影响接收后续考试信息。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { validatePhone, validatePwd } from '@/utils/validate'
import { getCode, getCodeStatus } from '@/api/login'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePwd, trigger: 'blur' }
        ]
      },
      needReload: false,
      maxTimes: 36,
      currentTimes: 1,
      uuid: '',
      codeUrl: ''
    }
  },
  mounted() {
    this.getLoginCode()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    handleLogin(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          that.$store.dispatch('user/login', this.form)
            .then((res) => {
              if (res.code === 200) {
                that.$router.push('/index')
              }
              that.loading = false
            })
        }
      })
    },
    getUUID() {
      return Math.random()
        .toString(36)
        .substr(3, 20)
    },
    getLoginCode() {
      this.loading = true
      this.uuid = this.getUUID()
      getCode({
        type: 'pc',
        key: this.uuid
      })
        .then(res => {
          let blob = new Blob([res], {type: 'image/jpeg'})
          this.codeUrl = window.URL.createObjectURL(blob)
          this.loading = false
          this.getLoginStatus()
        })
        .catch(() => {
          this.loading = false
        })
    },
    getLoginStatus() {
      let that = this
      that.timer = setInterval(function(){
        that.currentTimes++
        if (that.currentTimes >= that.maxTimes) {
          that.needReload = true
          clearInterval(that.timer)
          return
        }
        getCodeStatus({
          key: that.uuid
        })
          .then(res => {
            if (res.code === 200) {
              if (res.data.status === 1) {
                clearInterval(that.timer)
                that.$store.dispatch('user/updateToken', res.data.tokenHead + res.data.token)
                that.$router.push('/')
              } else if (res.data.status === 2) {
                if (res.data.openId) {
                  clearInterval(that.timer)
                  that.$router.push('/improveInfo?openId=' + res.data.openId + '&unionId=' + res.data.unionId)
                } else {
                  that.$message.success('关注成功，请扫码登录')
                }
              }
            }
          })
      }, 5000)
    },
    refreshCode() {
      this.currentTimes = 1
      this.needReload = false
      clearInterval(this.timer)
      this.getLoginCode()
    }
  }
}
</script>

<style lang="scss" scoped>
.login-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('../assets/bg1.png');
  background-size: 100% 100%;
  .mask-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .top-content {
    margin-top: 5%;
    margin-bottom: 40px;
    .head-name {
      font-size: 34px;
      color: #fff;
      text-decoration-line: none;
    }
    .head-title {
      font-size: 30px;
      font-weight: 700;
      margin-top: 50px;
      text-align: center;
    }
  }
  .login-from {
    width: 70%;
    max-width: 500px;
    .operate {
      width: 100%;
      .width-btn {
        width: 100%;
      }
    }
    .flex-operate {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }
  }
  .card-content {
    width: 340px;
    box-shadow: 0 0 15px 4px rgba(0, 0, 0, 0.05);
    background: #fff;
    text-align: center;
    padding: 15px 30px;
    .head-title {
      font-size: 20px;
      color: #000;
      font-weight: 600;
      padding: 15px 0;
      margin-bottom: 30px;
      border-bottom: 1px solid #eeeeee;
      text-align: left;
    }
    .tip-text {
      margin:  10px 30px;
      color: #373737;
      font-size: 14px;
    }
    .tip-text-red {
      color: #E02433;
      font-size: 14px;
      margin-bottom: 30px;
    }
    .code-content {
      position: relative;
      .login-code {
        display: block;
        width: 200px;
        height: 200px;
        margin: 0 auto;
      }
      .code-mask {
        position: absolute;
        width: 200px;
        height: 200px;
        left: 70px;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}
</style>
